import React from "react";
import "./style.sass"
import { useNavigate } from "react-router-dom";

const StudentMenu=({active, rightContent})=>{
    let navigate = useNavigate();
    function handleClick(route) {
        navigate(route);
    }

    return (
        <div className={"student-menu-bar"}>
            <div className="student-menu-bar__left">
                <div onClick={()=>{handleClick("/my-courses")}} className={`menu-item ${active=="courses"?"active":""}`}>
                    Courses
                </div>
                <div onClick={()=>{handleClick("/students")}} className={`menu-item ${active=="students"?"active":""}`}>
                    Students
                </div>
                <div onClick={()=>{handleClick("/transaction-history")}} className={`menu-item ${active=="transactions"?"active":""}`}>
                    Transactions
                </div>
            </div>
            {rightContent ? <div className="student-menu-bar__right">{rightContent}</div> : null}
        </div>
    )
}
export default StudentMenu
